module.exports = __webpack_public_path__ + "d6ff5bb15f8bcf339f10059587d28463.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/home.svg
// module id = 757
// module chunks = 0